const getters = {
  loading:  state => state.loading,
}

export default getters